/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


import state from './moduleDevelopmentActionsState.js'
import mutations from './moduleDevelopmentActionsMutations.js'
import actions from './moduleDevelopmentActionsActions.js'
import getters from './moduleDevelopmentActionsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

